import { defineOutcome, type CatalogOutcomeDefinitionMap } from './catalogCapabilities.types';

export const dataCatalogOutcomeDefinitions: CatalogOutcomeDefinitionMap = {
  apollo: [
    defineOutcome('Find people and organizations', 'People, companies, roles, locations, and search filters', 'apollo.people_search', 'apollo.organizations_search'),
    defineOutcome('Enrich contact and company data', 'Emails, profiles, firmographics, funding, and technologies', 'apollo.person_enrich', 'apollo.organization', 'apollo.organization_enrich', 'apollo.organizations_bulk_enrich'),
    defineOutcome('Track company activity', 'Job openings, company news, categories, and timestamps', 'apollo.organization_jobs', 'apollo.organization_news'),
  ],
  email: [
    defineOutcome('Find professional emails', 'Names, company domains, and work email addresses', 'email.find'),
    defineOutcome('Verify email deliverability', 'Syntax, domain, and mailbox checks', 'email.verify'),
  ],
  github: [
    defineOutcome('Research developers and audiences', 'Profiles, followers, following, activity, and contributions', 'github.user', 'github.user_followers', 'github.user_following', 'github.user_activity', 'github.user_contributions'),
    defineOutcome('Analyze repositories and work', 'Repository details, user repositories, and pull requests', 'github.repository', 'github.user_repositories', 'github.user_pull_requests'),
    defineOutcome('Discover open source trends', 'Trending repositories, developers, languages, and stars', 'github.trending_repositories', 'github.trending_developers'),
  ],
  glassdoor: [
    defineOutcome('Find Glassdoor jobs', 'Fresh listings, keywords, locations, companies, and source links', 'glassdoor.jobs'),
  ],
  indeed: [
    defineOutcome('Find Indeed jobs', 'Fresh listings, keywords, locations, and countries', 'indeed.jobs'),
  ],
  maps: [
    defineOutcome('Discover places and businesses', 'Search results, place details, ratings, and addresses', 'maps.search', 'maps.place'),
    defineOutcome('Analyze customer reviews', 'Review text, ratings, authors, and dates', 'maps.reviews'),
    defineOutcome('Find business contacts', 'Phone numbers, websites, emails, and social links', 'maps.contacts'),
  ],
  person: [
    defineOutcome('Find people and contact data', 'Identity, addresses, phones, emails, and matching records', 'person.skip_trace'),
  ],
  realtor: [
    defineOutcome('Discover Realtor.com properties', 'Listings, prices, locations, home facts, and search filters', 'realtor.search'),
  ],
  redfin: [
    defineOutcome('Discover Redfin properties', 'Listings, prices, locations, home facts, and search filters', 'redfin.search'),
  ],
  social: [
    defineOutcome('Find social profiles', 'People and brand accounts across major social networks', 'social.finder'),
  ],
  upwork: [
    defineOutcome('Find freelance opportunities', 'Fresh job posts, keywords, budgets, and client details', 'upwork.jobs'),
  ],
  yelp: [
    defineOutcome('Discover local businesses', 'Listings, ratings, categories, locations, and business details', 'yelp.search'),
  ],
  zillow: [
    defineOutcome('Discover property listings', 'For-sale, rental, and sold homes with detailed filters', 'zillow.search'),
    defineOutcome('Research individual properties', 'Prices, features, photos, and price and tax history', 'zillow.property'),
  ],
};
